const { ERROR_MESSAGES, SERVER_URL } = require('./constants');

class HTTPRequest {
    constructor(serverUrl) {
        this.url = serverUrl;
        this.headers = { 'Content-Type': 'application/json' };
        this.credentials = 'include';
    }

    async _handleResponse(res) {
        const data = await res.json();

        // If response is OK, return the data
        if (res.ok) return data;

        // Handle errors based on status code
        const errMsg = data?.message || res.statusText || `Error fetching data: ${res.status}`;
        if (res.status === 400) throw new Error(errMsg || ERROR_MESSAGES.BAD_REQUEST);
        if (res.status === 401) throw new Error(errMsg || ERROR_MESSAGES.INVALID_CREDENTIALS);
        if (res.status === 403) throw new Error(errMsg || ERROR_MESSAGES.FORBIDDEN_ACCESS);
        if (res.status === 404) throw new Error(errMsg || ERROR_MESSAGES.NOT_FOUND);
        throw new Error(errMsg);
    }

    async get(path = '/', params = {}) {
        const query = new URLSearchParams(params).toString();
        const fullUrl = query ? `${this.url}${path}?${query}` : `${this.url}${path}`;
        const res = await fetch(fullUrl, {
            method: 'GET',
            headers: this.headers,
            credentials: this.credentials
        });
        return this._handleResponse(res);
    }
    async post(path = '/', body = {}) {
        const fullUrl = `${this.url}${path}`;
        const res = await fetch(fullUrl, {
            method: 'POST',
            headers: this.headers,
            credentials: this.credentials,
            body: JSON.stringify(body)
        });
        return this._handleResponse(res);
    }
    async put(path = '/', body = {}) {
        const fullUrl = `${this.url}${path}`;
        const res = await fetch(fullUrl, {
            method: 'PUT',
            headers: this.headers,
            credentials: this.credentials,
            body: JSON.stringify(body)
        });
        return this._handleResponse(res);
    }
}

const api = new HTTPRequest(SERVER_URL);
module.exports = { api };